if (!customElements.get("product-slider")) {
  customElements.define(
    "product-slider",
    class ProductSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {}

      init() {
        this.slider = new Swiper(this.querySelector('.product-grid'), {
          slidesPerView: 2,
          loop: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            1200: {
              slidesPerView: 4,
            },
            989: {
              slidesPerView: 4,
            },
            768: {
              slidesPerView: 3,
            },
          },
        });
      }
    }
  );
}
